import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { ParaApiRootService } from './para-api-root.service';
import { ParaStudentHistoryService } from './para-student-history.service';

@Injectable({ providedIn: 'root' })
export class ParaScoreSubmitService {
	constructor(
		private readonly http: HttpClient,
		private readonly paraApi: ParaApiRootService,
		private readonly paraStudentHistory: ParaStudentHistoryService
	) {}

	submitScores(payload: {
		scores: any;
		nodeId?: number | null;
		/** PARA assessment slug; must match roster / LMS story pack (e.g. para-ce-screener-transform). */
		assessmentId: string;
	}): Observable<any> {
		return this.http.post<any>(this.paraApi.assessmentUrl('addScores'), payload).pipe(
			tap(() => this.invalidateStudentHistoryAfterSubmit(payload))
		);
	}

	private invalidateStudentHistoryAfterSubmit(payload: {
		scores: any;
		nodeId?: number | null;
		assessmentId: string;
	}): void {
		const nodeId = payload.nodeId;
		if (nodeId == null) return;
		const scores = payload.scores;
		if (!scores || typeof scores !== 'object') return;
		const seen = new Set<number>();
		for (const entry of Object.values(scores)) {
			const pid = Number((entry as { participantId?: unknown })?.participantId);
			if (!Number.isFinite(pid)) continue;
			if (seen.has(pid)) continue;
			seen.add(pid);
			this.paraStudentHistory.invalidate(nodeId, pid);
		}
	}
}

